import React from 'react';
interface SliderProps {
  label: string;
  value: number;
  min: number;
  max: number;
  step?: number;
  onChange: (val: number) => void;
}
export function Slider({
  label,
  value,
  min,
  max,
  step = 1,
  onChange
}: SliderProps) {
  return <div className="flex flex-col gap-1.5" data-id="element-43">
      <div className="flex justify-between items-center" data-id="element-44">
        <label className="text-xs font-medium text-slate-700" data-id="element-45">{label}</label>
        <span className="text-xs text-slate-500 font-mono" data-id="element-46">{value}</span>
      </div>
      <input type="range" min={min} max={max} step={step} value={value} onChange={e => onChange(parseFloat(e.target.value))} className="w-full h-1.5 bg-slate-200 rounded-lg appearance-none cursor-pointer accent-indigo-500" data-id="element-47" />
    </div>;
}